import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";
import React, { useEffect, useRef, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useForm } from "react-hook-form";
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import { RxCross1, RxCross2 } from 'react-icons/rx';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import HttpHelper from '../../service/httpService';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";
import DashboardWrapper from './DashboardWrapper';
const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell,
} = EditorTools;

const initialDataState = {
    skip: 0,
    take: 15,
};

const SecurityObjectName = 'Website.Pages';

const DashboardPage = (props) => {
    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);


    const [page, setPage] = React.useState(initialDataState);
    const [pageSizeValue, setPageSizeValue] = React.useState();

    const [pages, setPages] = useState({});
    const [updatingPage, setUpdatingPage] = useState({});
    const { register, handleSubmit, watch, reset, setValue, formState: { errors },
        clearErrors } = useForm({});
    const [isEditing, setIsEditing] = useState(false);
    const [contentData, setContentData] = useState("");
    const [imagePath, setImagePath] = useState(null);
    const [progress, setProgress] = useState(0);
    const [OriginalImage, setOriginalImage] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const [pageIdUpdate, setPageIdUpdate] = useState();
    const [fileIdUpdate, setFileIdUpdate] = useState();
    const [fileDetailsUpdate, setFileDetailsUpdate] = useState();
    const [rowVersion, setRowVersion] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');
    const [accordianStatus, setAccordianStatus] = useState('0');
    const [fileId, setFileId] = useState('');
    const editor = useRef();
    const AccordianHandle = useRef();

    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);

    const onSubmit = async (data, event) => {
        setLoaderApi(true);

        const fileData = new FormData();
        if (data.file && data.file[0]) {
            fileData.append('file', data.file[0])
            fileData.append('Folder', 'Page')
            HttpHelper.post("Page/UploadFileAsync", fileData, { headers: { 'Content-Type': 'multipart/form-data; charset=utf-8' } }).then((response) => {
                if (response.status == 200) {
                    data.FileId = response.data[0].fileId;
                    delete data.file;

                    if (isEditing === true) {
                        PageUpdate(data, data.FileId, true);
                    }
                    else {
                        PageAdd(data, data.FileId, true);
                        event.target.reset();
                    }
                };
            });
        }
        else {
            delete data.file;
            if (isEditing === true) {
                PageUpdate(data, data.FileId, false);
            }
            else {
                PageAdd(data, data.FileId, true);
                event.target.reset();
            }
        }
    };

    const PageUpdate = async (data, fileIdImg, uploadImg) => {

        Object.assign(data,
            {
                slug: data.title.toLowerCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '')
            }
        );
        if (uploadImg) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { pageId: pageIdUpdate },
                { fileId: fileIdImg },
                { image: null }
            );
            await HttpHelper.put("page", data).then((response) => {
                props.showToast('success', 'Page updated successfully');
                setLoaderApi(false);
                setPopupAddEdit(false);
                setValue("content", "");
                setImagePath(null);
                setOriginalImage("");
                setValue("pageId", null);
                setContentData("");
                GetPages();
                setLoaderApi(false);
                setPopupAddEdit(false);
                BlankDetails();
                const view = editor.current.view;
                if (view) {
                    EditorUtils.setHtml(view, '');
                }
                setValue('title', '');
                setValue('description', '');
                setAccordianStatus('0');
                accordianStatusHandle();
                setIsEditing(false);
            }).catch((error) => {
                setLoaderApi(false);
                console.log(error);
            })
        }
        else {
            debugger;
            Object.assign(data,
                { rowVersion: rowVersion },
                { primaryKeyEncrypted: primaryKeyEncrypted },
                { pageId: pageIdUpdate },
                { fileId: fileId }
            );
            await HttpHelper.put("page", data).then((response) => {
                props.showToast('success', 'Page updated successfully');
                setLoaderApi(false);
                setPopupAddEdit(false);
                setValue("content", "");
                setImagePath(null);
                setOriginalImage("");
                setValue("pageId", null);
                setIsEditing(false);
                setContentData("");
                setFileId('');
                GetPages();
                accordianStatusHandle();
                const view = editor.current.view;
                if (view) {
                    EditorUtils.setHtml(view, '');
                }
                setValue('title', '');
                setValue('description', '');
            }).catch((error) => {
                console.log(error);
            })
        }
    }

    const PageAdd = async (data, fileId, uploadImg) => {
        delete data.pageId;
        Object.assign(data,
            {
                slug: data.title.toLowerCase()
                    .trim()
                    .replace(/[^\w\s-]/g, '')
                    .replace(/[\s_-]+/g, '-')
                    .replace(/^-+|-+$/g, '')
            }
        );

        Object.assign(data,
            { fileId: fileId }
        );


        if (uploadImg) {
            await HttpHelper.post("page", data).then((response) => {
                if (response.status) {
                    props.showToast('success', 'Page Added successfully');
                    setValue("content", "");
                    setImagePath(null);
                    setOriginalImage("");
                    setValue("pageId", null);
                    setIsEditing(false);
                    setContentData("");
                    GetPages();
                    setLoaderApi(false);
                    setPopupAddEdit(false);
                    BlankDetails();
                    const view = editor.current.view;
                    if (view) {
                        EditorUtils.setHtml(view, '');
                    }
                    setValue('title', '');
                    setValue('description', '');
                    accordianStatusHandle();
                } else {
                    props.showToast('error', response.data);
                }
            }).catch((error) => {
                setLoaderApi(false);
                console.log(error);
            })
        } else {
            await HttpHelper.post("page", data).then((response) => {

                if (response.status) {
                    props.showToast('success', 'Page Added successfully');
                    setLoaderApi(false);
                    setPopupAddEdit(false);
                    setValue("content", "");
                    setImagePath(null);
                    setOriginalImage("");
                    setIsEditing(false);
                    setContentData("");
                    GetPages();
                    setValue('title', '');
                    setValue('description', '');
                    accordianStatusHandle();
                    BlankDetails();
                    const view = editor.current.view;
                    if (view) {
                        EditorUtils.setHtml(view, '');
                    }
                } else {
                    props.showToast('error', response.data);
                }
            }).catch((error) => {
                console.log(error);
            })
        }
    }

    const deleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Page/DeleteAsync??fileId=" + fileId).then((res) => {
        }).catch((error) => {
            console.log(error);
        })
    }

    const updatePage = async (pageId) => {
        setLoaderApi(true);
        setValue('file', '');
        await HttpHelper.get("page/" + pageId).then((response) => {
            setLoaderApi(false);
            clearErrors();
            setIsEditing(true);
            setUpdatingPage(response.data);
            setValue("title", response.data.title);
            setValue("description", response.data.description);
            setValue("content", response.data.content);
            setContentData(response.data.content);
            setImagePath(response.data.byteImage);
            setValue("pageId", response.data.pageId);
            setOriginalImage(response.data.image);
            setIsActive(response.data.isActive);
            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);
            setPageIdUpdate(response.data.pageId)
            setFileDetailsUpdate(response.data.file ? response.data.file : '');
            setLoaderApi(false);
            setFileIdUpdate(response.data.pageId)
            setRowVersion(response.data.rowVersion)
            setValue('fileId', response.data.fileId)
            setFileId(response.data.fileId)
            setProgress(100);
            setAccordianStatus('1');
        })

    }

    const GetPages = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Page").then((response) => {
            setPages(response.data.data);
            setPageSizeValue(response.data.data.length);
            setProgress(100);
            getAllPermission();
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })
    }

    const deletePage = async (pageId) => {
        if (pageId == null || pageId == undefined) {
            return false;
        }
        swal("Are you sure, you want to delete this page?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    await HttpHelper.delete("page/" + pageId).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Page Delete successfully');
                            GetPages();
                        } else {
                            props.showToast('error', response.data);
                        }
                    }).catch((error) => {
                        console.log(error);
                    })

                }
            });

    }

    const accordianStatusHandle = (elem) => {
        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }

    const BlankDetails = () => {
        setIsEditing(false);
        setValue('title', '');
        setValue('description', '');
        setValue('content', '');
        setContentData('');
        setFileId('');
    }

    const initRender = (e) => {
        if (e == 200) {
            GetPages();
        }
    }

    const pageChange = (event) => {
        const targetEvent = event.syntheticEvent;
        const take = targetEvent.value === "All" ? pages.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

 
    useEffect(() => {
        GetPages();
    }, [])

    return (
        <>
            <DashboardWrapper>
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard progress={progress} title="Website Page" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign d-none">
                                </div>
                                {hasAddPermissionUser == true ? <div className="col-auto mb-2">
                                    {popupAddEdit === false ?
                                        <button onClick={() => {
                                            BlankDetails();
                                            accordianStatusHandle('1');
                                            setPopupAddEdit(true);
                                        }} className="btn btnSave">Add New Page</button> : ''}
                                </div> : ''}

                                {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 table-responsive">
                                    <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                        <table className="table tableCustomized table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Title
                                                    </th>
                                                    <th>
                                                        Description
                                                    </th>
                                                    <th>
                                                        Slug
                                                    </th>
                                                    <th>
                                                        Is Active?
                                                    </th>
                                                    <th>
                                                        Actions
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pages.length > 0 ? pages.map((page, index) => {

                                                        return (<>
                                                            <tr key={index} className="sno">
                                                                <td>
                                                                    {page.title}
                                                                </td>
                                                                <td>
                                                                    {page.description}
                                                                </td>
                                                                <td>
                                                                    {page.slug}
                                                                </td>
                                                                <td>
                                                                    {page.isActive == 1 ? 'Yes' : 'No'}
                                                                </td>
                                                                {hasDeletePermissionUser == true || hasEditPermissionUser == true ? <td>
                                                                    {hasEditPermissionUser == true ? <CiEdit onClick={() => {
                                                                        setPopupAddEdit(true);
                                                                        updatePage(page.pageId);
                                                                    }} /> : ''}
                                                                    {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { deletePage(page.pageId) }} /> : ''}
                                                                </td> : ''}
                                                            </tr>
                                                        </>)
                                                    })
                                                        : <tr><td colSpan={6}>No Page found!!!</td></tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}

                                <div className="col-md-12 mb-2">
                                </div>
                                {hasReadPermissionUser || hasEditPermissionUser || hasAddPermissionUser ? <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                    {hasReadPermissionUser == true ? <Accordion.Item className="d-none" eventKey="0" onClick={() => {
                                        accordianStatusHandle();
                                    }}>
                                        <Accordion.Header>Grid Pages</Accordion.Header>
                                        <Accordion.Body onClick={(e) => {
                                            e.stopPropagation();
                                        }}>
                                            <div className="col-md-12 mb-2">
                                                <div className="cardBox cardTableWrapperDashboard">
                                                    <table className="table tableCustomized table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    #
                                                                </th>
                                                                <th>
                                                                    Title
                                                                </th>
                                                                <th>
                                                                    Description
                                                                </th>
                                                                <th>
                                                                    Slug
                                                                </th>
                                                                <th>
                                                                    Is Active?
                                                                </th>
                                                                <th>
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                pages.length > 0 ? pages.map((page, index) => {

                                                                    return (<>
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {index + 1}
                                                                            </td>
                                                                            <td>
                                                                                {page.title}
                                                                            </td>
                                                                            <td>
                                                                                {page.description}
                                                                            </td>
                                                                            <td>
                                                                                {page.slug}
                                                                            </td>
                                                                            <td>
                                                                                {page.isActive == 1 ? 'Yes' : 'No'}
                                                                            </td>
                                                                            {
                                                                                hasDeletePermission('Website.Pages') || hasDeletePermission('Website.Pages') ?
                                                                                    <td>
                                                                                        {hasEditPermission('Website.Pages') == true ? <CiEdit onClick={() => { updatePage(page.pageId) }} /> : ''}
                                                                                        {hasDeletePermission('Website.Pages') == true ? <AiOutlineDelete onClick={() => { deletePage(page.pageId) }} /> : ''}
                                                                                    </td>
                                                                                    : ''
                                                                            }
                                                                        </tr>
                                                                    </>)
                                                                })
                                                                    : <tr><td colSpan={6}>No Page found!!!</td></tr>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : ''}
                                </Accordion> : ''}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                    <div className="crossPopup" onClick={() => {
                        setShowImgPopup(false);
                        setImageCurrentShow('');
                    }}>
                        <RxCross1 />
                    </div>
                    <img src={imageCurrentShow} />
                </div>

                {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Page" : "Add Page"}</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Title : <span class="requiredAstric"> *</span></label>
                                        <input type="text" {...register("title", { required: true })} className="border mb-2" placeholder="Title" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.title?.type === 'required' && <p className="text-danger custom_error" role="alert">This field is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>File : <span class="requiredAstric"> *</span></label>
                                        <br />
                                        <label>{fileDetailsUpdate != null ? fileDetailsUpdate.originalFileName : ''} </label>
                                        <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" onChange={(e) => { }} />
                                        {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Description : <span class="requiredAstric"> *</span></label>
                                        <input type="text" {...register("description", { required: true })} className="border mb-2" placeholder="description" aria-invalid={errors.Heading ? "true" : "false"} />
                                        {errors.description?.type === 'required' && <p className="text-danger custom_error" role="alert">This field is required</p>}
                                    </div>

                                    <div className="col-md-12">
                                        <label>Content :</label>
                                        <Editor
                                            tools={[
                                                [Bold, Italic, Underline, Strikethrough],
                                                [Subscript, Superscript],
                                                [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                [Indent, Outdent],
                                                [OrderedList, UnorderedList],
                                                [FontSize, FontName],
                                                FormatBlock,
                                                [Undo, Redo],
                                                [Link, Unlink, ViewHtml],
                                                [InsertTable],
                                                [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                [DeleteRow, DeleteColumn, DeleteTable],
                                                [MergeCells, SplitCell],
                                            ]}
                                            ref={editor}
                                            defaultContent={contentData}
                                            onChange={(e) => {
                                                const regex = /(<([^>]+)>)/gi;
                                                const result = e.html.replace(regex, "");
                                                if (result.length > 0)
                                                    setValue('content', e.html);
                                                else
                                                    setValue('content', null);

                                            }}
                                        />
                                        <textarea className="border d-none" {...register("content", { required: true })} placeholder="Content"></textarea>
                                        {errors.content?.type === 'required' && <p className="text-danger" role="alert"> Content is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>
                                            <input type="checkbox" {...register("isActive", { required: false })} className="border mb-2" placeholder="Heading" aria-invalid={errors.Heading ? "true" : "false"}
                                                onChange={(e) => {
                                                    if (e.currentTarget.checked === true) {
                                                        setIsActive("isActive", true)
                                                    } else {
                                                        setIsActive("isActive", false)
                                                    }
                                                }} />
                                            &nbsp;Is Active?</label>

                                    </div>
                                    {
                                        isEditing === true ?
                                            <input type="hidden" {...register('pageId', { required: false })} name="pageId" />
                                            : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                        <div>
                                            <button className="btn btnSave mt-2" >Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''
                }
            </DashboardWrapper>
        </>
    )
}

export default DashboardPage;